export default __webpack_public_path__ + "advantage-1039d53.png";